import { Loading } from "design_system/components/Loading";

const WholePageLoading = () => {
  return <Loading size={61} h="100vh" />;
};

export default WholePageLoading;
